module.exports = __webpack_public_path__ + "images/138_640.jpg";